class Caret extends React.Component {
  render () {
    return (
      <li className="section__item">
        <h3 className="section__item-title" id="caret">
          Caret
          <span className="section__item-docs">
            Documentation: <a href="docs/scss#mixins-mixin-caret" target="_blank">SCSS</a>
          </span>
        </h3>
        <div className="section__demo">
          <Collapser>
            <div className="demo">
              <h4 className="demo__title">All Carets</h4>
              <div className="demo__code">
                <CodeBlock lang="html">{`
<div class="caret-demo">
  <div class="caret caret-up"></div>
  <div class="caret caret-down"></div>
  <div class="caret caret-left"></div>
  <div class="caret caret-right"></div>
</div>
                `}
                </CodeBlock>
                <CodeBlock lang="scss">
                {`
.caret-demo {
  .caret {
    display: inline-block;
    margin-right: 20px;
  }

  .caret-up {
    @include caret();
  }

  .caret-down {
    @include caret($direction: down);
  }

  .caret-left {
    @include caret($direction: left, $size: 50px);
  }

  .caret-right {
    @include caret($direction: right, $size: 30px, $color: $weird-green);
  }
}
                `}
                </CodeBlock>
              </div>
              <div className="demo__output">
                <Output>
                  <div className="caret-demo">
                    <div className="caret-up caret"></div>
                    <div className="caret-down caret"></div>
                    <div className="caret-left caret"></div>
                    <div className="caret-right caret"></div>
                  </div>
                </Output>
              </div>
            </div>
          </Collapser>
        </div>
      </li>
    );
  }
};

